<template>
	<div>
		<div class="content" v-if="type==1">
			<div class="item">
				<span class="title">流水号</span>
				<span class="value">{{detail.batch_serial_number}}</span>
			</div>
		
			<div class="item">
				<span class="title">备注</span>
				<span class="value">{{detail.describe}}</span>
			</div>
		
			<div class="item">
				<span class="title">交易类型</span>
				<span class="value">
					<span v-if="detail.type==='1'">收入</span>
					<span v-else>支出</span>
				</span>
			</div>
		
			<div class="item">
				<span class="title">金额</span>
				<span class="value">{{detail.amount}}</span>
			</div>
			
			<div class="item">
				<span class="title">我的余额</span>
				<span class="value">{{detail.now_balance}}</span>
			</div>
		</div>
		
		<!-- 体现记录详情 -->
		<div class="content" v-if="type==2">
			<div class="item">
				<span class="title">流水号</span>
				<span class="value">{{detail.withdrawal_code}}</span>
			</div>
		
			<div class="item">
				<span class="title">姓名</span>
				<span class="value">{{detail.bank_info.user_identity_card_name}}</span>
			</div>
		
			<div class="item">
				<span class="title">交易类型</span>
				<span class="value">
					<span v-if="detail.status==3">收入</span>
					<span v-else>支出</span>
				</span>
			</div>
			
			<div class="item">
				<span class="title">银行名称</span>
				<span class="value">{{detail.bank_info.bank_name}}</span>
			</div>
			
			<div class="item">
				<span class="title">银行卡号</span>
				<span class="value">{{detail.bank_info.bank_code}}</span>
			</div>
			
			<div class="item">
				<span class="title">申请时间</span>
				<span class="value">{{detail.create_time}}</span>
			</div>
		
			<div class="item">
				<span class="title">金额</span>
				<span class="value">{{detail.amount}}</span>
			</div>
			
			<div class="item">
				<span class="title">我的余额</span>
				<span class="value">{{detail.now_balance}}</span>
			</div>
			
			<div class="item">
				<span class="title">状态</span>
				<span class="value">{{detail.statusName}}</span>
			</div>
			
			<div class="item" v-if="detail.reasons_for_refusal">
				<span class="title">拒绝原因</span>
				<span class="value">{{detail.reasons_for_refusal}}</span>
			</div>
		</div>
		
		
	</div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader'

export default {
	name: 'balancedetail',
	components: {
		CommonHeader
	},
		
	data() {
		return {
			detail:sessionStorage.getItem("balance")?JSON.parse(sessionStorage.getItem("balance")):"",
			type:this.$route.query.type?this.$route.query.type:""
		}
	},
	
	beforeCreate(){
		sessionStorage.removeItem("roleType");
	},
	
	created() {
		if(this.type == 2){
			if(this.detail && this.detail.status){
				if(this.detail.status=="1"){
					this.detail.statusName = "待审核"
				}else if(this.detail.status=="2"){
					this.detail.statusName = "通过"
				}else if(this.detail.status=="3"){
					this.detail.statusName = "拒绝"
				}
			}
		}
	},
    
    mounted(){
       document.title = "详情"
    },
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variable.less';
@import '~@/assets/styles/handleMethods.less';
@import '~@/assets/styles/reset.css';
.content {margin:18px 22px 0 22px;font-size: 14px;font-family:PingFangSC-Medium;font-weight:500;}
.item {display: flex;justify-content: space-between;font-family:PingFangSC-Medium;font-weight:500;margin-bottom: 12px}
.title {color:rgba(155,155,155,1)}
.value {color:rgba(74,74,74,1);}

</style>